const 	feedbackButton = document.querySelector(".js-feedback-button"),
		feedbackForm = document.querySelector(".js-feedback-form");

if ( feedbackButton && feedbackForm ) {

	function showForm() {

	    feedbackButton.style.display = "none";
	    feedbackForm.style.display = "block";

	}

	feedbackButton.addEventListener('click', showForm);

}